import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Features, Team, Banner, Calculator, WhyChooseUs, Clients, Process, Pricing, PortfolioSection } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <WhyChooseUs /> {/* Why Choose Us section */}
      <Process /> {/* Process section */}
      <Banner /> {/* Banner Section */}
      <PortfolioSection /> {/* Portfolio Section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <Calculator /> {/* Cost Calculator */}
      <Pricing /> {/* Pricing section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Clients /> {/* Clients Slider */}
    </div>
  )

}

export default HomePage;